import React from "react";
import { Tag } from "antd";

// Map status names to Ant Design Tag colors
const getStatusColor = (statusName) => {
  switch (statusName) {
    case "Draft":
      return "default";
    case "Pending Approval":
      return "processing";
    case "Under Negotiation":
      return "blue";
    case "Accepted":
      return "success";
    case "Rejected":
      return "error";
    case "On Hold":
      return "warning";
    case "Expired":
      return "error";
    case "Converted to Order":
      return "success";
    default:
      return "default";
  }
};

const StatusBadge = ({ status }) => (
  <Tag color={getStatusColor(status)}>{status}</Tag>
);

export default StatusBadge; 